module.exports = __webpack_public_path__ + "static/img/bystage_10.2dd682aa.svg";